import {CmsDynamicSectionOptionsArray} from './CmsDynamicSection';

/**
 * The string values must match with the CMS functional type keys referenced in CmsDynamicSection.
 * If a matching key/component is found then the section name will not be rendered.
 * It is then assumed that the first component of the section will be able to handle the section name eyebrow.
 */
const functionalKeysWithSectionNameSupport = [
    'overviewGrid',
    'caseStudy',
    'sectionIntroWithBackground',
    'textBlockLeftAligned',
    'download',
    'introWithCards'
];

export const determineSectionNameSupport = (items: CmsDynamicSectionOptionsArray = []): boolean => {
    let hasSupport = false;
    if (!items || !items.length) return false;

    const firstItem = items[0] || {};
    delete firstItem._type;
    const itemLength = Object.keys(firstItem).length;
    if (firstItem && itemLength) {
        for (const key in firstItem) {
            if (Object.prototype.hasOwnProperty.call(firstItem, key)) {
                if (functionalKeysWithSectionNameSupport.includes(key)) {
                    hasSupport = true;
                }
            }
        }
    }

    return hasSupport;
};

export const functionalKeysNeverBottomPadding = ['download'];

export const functionalKeysAlwaysTopPadding = ['download'];
